import React, { useState, useEffect } from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { LoginManager } from '../../core/login-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MessageToggle from '../components/MessageToggle';


export default function HeaderHook() {


    const navigate = useNavigate();
    const userInfo = LoginManager.getUserInfo();
    const [savedCustomer, setSavedCustomer] = useState(null)

    useEffect(() => {
        try {
            let a = localStorage.getItem("selectedCustomer")
            let b = JSON.parse(a)
            setSavedCustomer(b)
        } catch (e) {
            console.warn('not a json')
        }
    }, []);


    function changeCustomer() {
        navigate('/page/SelectCustomer')
    }

    function removeCustomer() {
        localStorage.removeItem("selectedCustomer")
        setSavedCustomer(null)
        window.location.reload()
    }


    return (
        <div className='ms-4 me-auto d-flex align-items-center gap-2'>
            {userInfo && userInfo.level != 2 ? (
                <InputGroup size='sm' style={{ maxWidth: 400 }}>
                    <Button variant="outline-secondary" style={{ fontSize:11 }} onClick={() => changeCustomer()}>
                        Cambia<br/>cliente
                    </Button>
                    <InputGroup.Text style={{ fontSize:11 }}>
                        {savedCustomer ? savedCustomer.label.substring(0, 30) : 'Nessun cliente selezionato'}
                    </InputGroup.Text>
                    <Button variant="outline-danger" onClick={() => removeCustomer()}>
                        <FontAwesomeIcon icon="times" />
                    </Button>
                </InputGroup>
            ) : (
                <></>
            )}
            <MessageToggle />
        </div>
    )
};